import { safeGet, baseUrl } from './http'

export const getLanguages = () => safeGet(`${baseUrl}/languages`)
